<template>
  <tr
    v-if="user"
    class="customer-item"
    style="cursor: pointer"
    @click="
      showModal = true
      fetchScore()
    "
  >
    <td>
      <v-avatar size="30">
        <img
          v-if="user.profile_pic"
          :src="user.profile_pic"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
          @error="onFailLoad"
        />
        <img
          v-else
          :src="'/static/img/assets/livechat/profile.png'"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
      </v-avatar>
    </td>
    <td
      style="min-width: 300px"
      :title="
        (user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '')
      "
    >
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{
          ((user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : ''))
            | truncate(35)
        }}
      </div>
    </td>
    <td>
      <span v-if="user.app == 'facebook'" style="color: #3b5998">
        <em class="fab fa-facebook-square" />
      </span>
      <span v-else-if="user.app == 'line'" style="color: #00c300">
        <em class="fab fa-line" />
      </span>
    </td>
    <td>{{ user.gender ? $t(user.gender) : '-' }}</td>
    <td style="white-space: nowrap">
      <!-- age -->
      {{ user.age ? user.age : json && json.age ? json.age : '-' }}
    </td>

    <td>
      <!-- pdpa -->
      {{ json && json.pdpa == true ? 'Agree' : json && json.pdpa == false ? 'Disagree' : '-' }}
    </td>
    <td>
      <v-btn outline fab small class="extra-small">
        <em class="fas fa-align-left" />
      </v-btn>

      <v-dialog v-model="showModal" width="800">
        <v-card>
          <v-tabs v-model="workplacetab" color="white" :slider-color="$vuetify.theme.primary">
            <v-tab :key="'Info'" ripple :href="'#Info'">{{ $t('Info') }}</v-tab>
            <v-tab :key="'Score'" ripple :href="'#Score'">{{ $t('Score') }}</v-tab>
          </v-tabs>
          <div v-if="workplacetab == 'Info'">
            <customer-detail v-if="showModal" :key="user.id" v-model="user.id">
              <div slot="header" class="text-xs-right">
                <v-btn flat fab small class="extra-small" @click="showModal = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </customer-detail>
          </div>
          <div v-else-if="workplacetab == 'Score'" class="mt-3">
            <v-layout row>
              <v-avatar size="80" class="mx-3">
                <v-img
                  :lazy-src="user.profile_pic"
                  :src="user.profile_pic"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <template #placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-avatar>
              <div class="mt-3">
                <div>
                  {{ user.first_name ? user.first_name : '' }}
                  {{ user.last_name ? user.last_name : '' }}
                </div>
                <div>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</div>
              </div>
              <div
                v-if="currentScore"
                class="my-2 flex-all-center border-r-15"
                style="
                  margin-left: 1.5rem;
                  color: white;
                  font-weight: bold;
                  padding: 0 20px;
                  background-color: #f7856a;
                "
              >
                {{ currentScore.score }} / {{ currentScore.full_score }}
              </div>
              <div
                v-else-if="sumOverAllScore"
                class="my-2 flex-all-center border-r-15"
                style="
                  margin-left: 1.5rem;
                  color: white;
                  font-weight: bold;
                  padding: 0 20px;
                  background-color: #f7856a;
                "
              >
                {{ sumOverAllScore.score }} / {{ sumOverAllScore.full_score }}
              </div>
            </v-layout>
            <v-layout v-if="series && series.length" id="chart" row align-center justify-center>
              <apexchart
                :id="`chart-${updateChart}`"
                :key="`chart-${updateChart}`"
                :width="chartWidth"
                type="pie"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </v-layout>
            <div
              v-if="activeChater == null && overAllScore && overAllScore.length"
              style="display: flex; flex-wrap: wrap; flex-direction: row"
            >
              <div
                v-for="(item, index) in overAllScore"
                :key="`select-chapter-index-${index}`"
                style="width: 50%"
                class="flex-all-center"
              >
                <div
                  style="
                    flex-direction: column;
                    background-color: #ddd;
                    width: 80%;
                    cursor: pointer;
                  "
                  class="py-3 mb-5 border-r-15 flex-all-center hover-box-shadow"
                  @click="handleClickChapter(item)"
                >
                  <div>บทที่ {{ item.chapter }}</div>
                  <div>{{ item.score }} / {{ item.full_score }}</div>
                </div>
              </div>
            </div>
            <div v-if="activeChater != null" class="p-3">
              <v-layout>
                <v-flex shrink>
                  <v-select
                    v-if="showActiveChaList && showActiveChaList.length"
                    v-model="selectTime"
                    :items="timeData"
                    style="max-width: 110px; margin-top: 5px"
                    label="ครั้งที่"
                    hide-details
                    class="mr-2"
                    dense
                    solo
                  ></v-select>
                </v-flex>
                <v-flex shrink>
                  <v-select
                    v-if="showActiveChaList && showActiveChaList.length"
                    v-model="selectChapter"
                    style="max-width: 110px; margin-top: 5px"
                    :items="showActiveChaList"
                    hide-details
                    dense
                    solo
                  ></v-select>
                </v-flex>
                <v-flex
                  v-if="showLevel"
                  shrink
                  style="display: flex; justify-content: center; align-items: center"
                >
                  <div style="padding-left: 10px">
                    <span style="font-weight: bold; font-size: 18px">ระดับ :</span>
                    <span style="font-size: 18px">{{ level[activeLevel] }}</span>
                  </div>
                </v-flex>
              </v-layout>
              <div>
                <v-data-table
                  :headers="activeChaterHeaders"
                  :items="showQuestionData"
                  class="elevation-1"
                >
                  <template #items="props">
                    <tr>
                      <td>{{ props.item.chapterName }}</td>
                      <td>
                        {{ props.item.question }}
                        <span
                          class="ml-2"
                          style="cursor: pointer"
                          @click="clickShowFullQuestion(props.item.val.a_val, props.item.val)"
                        >
                          <em class="fas fa-search" />
                        </span>
                      </td>
                      <td>{{ props.item.choice }}</td>
                      <td>{{ props.item.score }}/{{ props.item.max_score }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>

          <v-card-text class="text-xs-center">
            <v-btn v-if="activeChater" class="mr-2" color="primary" @click="handleClickCloseChapter"
              >Back</v-btn
            >
            <v-btn outline color="grey" @click="showModal = false">{{ $t('cancel') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showFullQuestion" scrollable max-width="800px">
        <v-card>
          <h1 class="text-center">โจทย์คำถาม</h1>
          <div
            v-if="fullQuestionData && fullQuestionData.length"
            style="height: 60vh; overflow-x: auto"
          >
            <message-viewer
              v-model="fullQuestionData"
              show-quick-reply
              :quick-reply="quickReply"
              :show-profile="true"
            ></message-viewer>
          </div>
          <v-layout row wrap justify-center class="mt-4">
            <v-btn
              outline
              color="grey"
              @click="
                showFullQuestion = false
                fullQuestionData = []
              "
              >{{ $t('cancel') }}</v-btn
            >
          </v-layout>
        </v-card>
      </v-dialog>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import api from '@/api'
import CustomerDetail from './../../customer/CustomerDetail.vue'
import question from '@/assets/js/atomicData.js'
import MessageViewer from '@/components/elements/MessageViewer'
import Apexchart from 'vue-apexcharts'

export default {
  components: {
    Apexchart,
    CustomerDetail,
    MessageViewer
  },
  props: ['value', 'intentQuestions'],
  data: function () {
    return {
      currentScore: null,
      level: {
        E: 'Encourage',
        N: 'Standard',
        H: 'Challenge'
      },
      interestingData: {},
      ansData: {},
      times: [],
      selectTime: 'ครั้งที่1',
      fullQuestionData: [],
      quickReply: null,
      showFullQuestion: false,
      overAllScore: [],
      selected: 'ครั้งที่3',
      user: undefined,
      showModal: false,
      selectChapter: '',
      updateChart: 0,
      //   showModalScore: false,
      showAllIntent: false,
      isEditTag: false,
      usertag: '',
      workplacetab: 'Info',
      fullScore: {
        chap1: 81,
        chap2: 135,
        chap3: 0,
        chap4: 118,
        overAll: 334
      },
      activeChater: null,
      activeChaterHeaders: [
        { text: 'บทที่', value: 'chapter' },
        { text: 'คำถาม', value: 'question' },
        { text: 'ข้อที่ตอบ', value: 'answer' },
        { text: 'คะแนน', value: 'solve' }
      ],
      series: [],
      chartOptions: {
        colors: [
          '#30284d',
          '#775dd0',
          '#008ffb',
          '#00e396',
          '#feb019',
          '#ff4560',
          '#ff45f9',
          '#2453ff',
          '#24ff8e',
          '#24f4ff',
          '#2bff24',
          '#24e5ff',
          '#ffc054',
          '#afb500',
          '#96ff54',
          '#54ffcf',
          '#085200',
          '#546bff',
          '#ff5493',
          '#b158e8',
          '#166e2a',
          '#868c0d',
          '#8c480d',
          '#005237',
          '#0ea186',
          '#920ea1',
          '#520034',
          '#a10e53',
          '#520034',
          '#00b5a3',

          '#486e6a',
          '#48546e',
          '#6e486c',
          '#98ab71',
          '#ab9071',
          '#ab7171',
          '#ab71a1',
          '#5c1c1c',
          '#71a0ab',
          '#2d1c5c',
          '#173600',
          '#5c1c33',
          '#003631',
          '#00ff7b',
          '#36002d',
          '#95ff00',
          '#1900ff',
          '#ffc400',
          '#e5ff00',
          '#ff6f00',
          '#ff00e1',
          '#000000',
          '#787878',
          '#73ff69',
          '#668cad',
          '#fffa69',
          '#c369ff',
          '#cfcfcf',
          '#ff69c0',
          '#fff1d4'
        ],
        width: 500,
        chart: {
          type: 'pie'
        },
        labels: [],
        responsive: [
          {
            breakpoint: 400,
            options: {
              width: 300
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    haveLevel() {
      try {
        if (this.selectChapter) {
          let tempSubChapter = this.selectChapter.split('-')[1]
          return tempSubChapter && Number(tempSubChapter) > 10 ? true : false
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    },
    json() {
      try {
        if (this.value.json_variable) {
          return JSON.parse(this.value.json_variable)
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    question() {
      return question
    },
    chartWidth() {
      if (window.innerWidth < 500) {
        return 300
      } else {
        return 500
      }
    },
    sessionvalue() {
      const regex = /chap/gim
      const data = this.user.session.replace(regex, 'Chapter ')
      return this.user.session ? JSON.parse(data) : {}
    },
    timeData() {
      let data = []
      this.ansData[this.selectChapter].forEach((ele, index) => {
        data.push(`ครั้งที่${index + 1}`)
      })
      this.selectTime = data[data.length - 1]
      return data
    },
    showActiveChaList() {
      let data = []
      for (const key in this.ansData) {
        let keySplit = key.split('-')
        if (keySplit[0] == this.activeChater) {
          data.push(key)
        }
      }
      this.selectChapter = data[0]
      return data
    },
    showLevel() {
      if (this.selectChapter) {
        try {
          let chap = this.selectChapter.split('-')[0]
          if (parseInt(chap) > 10) {
            return true
          } else {
            return false
          }
        } catch (error) {
          return null
        }
      } else {
        return null
      }
    },
    activeLevel() {
      if (this.selectChapter && this.selectTime) {
        try {
          const chap = this.selectChapter
          const time = this.selectTime.split('ครั้งที่')[1]
          let level = null
          if (time) {
            level = this.ansData.level[chap][time - 1]
          }
          return level
        } catch (error) {
          return null
        }
      } else {
        return null
      }
    },
    chapterList() {
      let data = []
      for (const key in this.sessionvalue) {
        let chap = key.split(' ')
        chap = chap[1]
        if (chap) {
          chap = chap.split('_')
          chap = chap[0]
          if (chap.length > 2 && chap.length < 6 && parseInt(chap[0]) > 0) {
            data.push(chap)
          }
        }
      }
      return [...new Set(data)]
    },
    showQuestion() {
      let data = []
      this.chapterData.forEach((ele) => {
        if (ele.chapterName == this.selectChapter && this.sessionvalue[ele.intentname]) {
          let temp = ele
          temp.choice = this.sessionvalue[ele.intentname] ? this.sessionvalue[ele.intentname] : ''
          temp.score = this.sessionvalue[`${ele.intentname}_score`]
            ? this.sessionvalue[`${ele.intentname}_score`]
            : 0
          temp.val = this.intentQuestions.find((x) => x.intentname == ele.intentname)
          data.push(temp)
        }
      })
      return data
    },
    showQuestionData() {
      try {
        const vm = this
        if (vm.selectTime && vm.selectChapter) {
          let data = []
          let times = vm.selectTime.split('ครั้งที่')
          let session = vm.ansData[vm.selectChapter][times[1] - 1]
          const regex = /chap/gim
          session = session.replace(regex, 'Chapter ')
          const level =
            vm.activeLevel == 'N'
              ? '_ธรรมดา'
              : vm.activeLevel == 'E'
              ? '_อ่อน'
              : vm.activeLevel == 'H'
              ? '_เก่ง'
              : ''
          session = session = session ? JSON.parse(session) : null
          if (session) {
            vm.chapterData.forEach((ele) => {
              const regex = new RegExp(level, 'g')
              if (
                (level && ele.intentname.match(regex)) ||
                (vm.activeLevel == 'N' && !vm.haveLevel)
              ) {
                let intentname = ele.intentname.replace(/_ธรรมดา|_อ่อน|_เก่ง/gim, '')
                const mainChapter = parseInt(ele.chapterName.split('-')[0])
                if (
                  ele.chapterName == vm.selectChapter &&
                  session[intentname] &&
                  ((mainChapter > 10 && ele.intentname.match(level)) || mainChapter <= 10)
                ) {
                  let temp = ele
                  temp.choice = session[intentname] ? session[intentname] : ''
                  temp.score = session[`${intentname}_score`] ? session[`${intentname}_score`] : 0
                  temp.val = vm.intentQuestions.find((x) => {
                    return x.intentname.toLowerCase() == `${intentname.toLowerCase()}${level}`
                  })
                  data.push(temp)
                }
              }
            })
            return data
          } else {
            return []
          }
        } else {
          return []
        }
      } catch (error) {
        console.error(error)
        return []
      }
    },
    activeChaterList() {
      let data = []
      this.chapterList.forEach((chaptername) => {
        if (chaptername.match(`${this.activeChater}-`)) {
          data.push(chaptername)
        }
      })
      data = data.sort()
      this.selectChapter = data[0]
      return data.sort()
    },
    chapterData() {
      let data = []
      this.chapterList.forEach((chaptername) => {
        this.question.forEach((questionData) => {
          let subChapter = questionData.intentname.split(' ')
          subChapter = subChapter[1]
          subChapter = subChapter.split('_')
          subChapter = subChapter[0]
          if (questionData.intentname.match(chaptername) && chaptername == subChapter) {
            let temp = {
              ...questionData,
              chapterName: chaptername
            }
            data.push(temp)
          }
        })
      })
      return data
    },
    sumOverAllScore() {
      let output = {
        score: 0,
        full_score: 0
      }
      if (this.overAllScore.length) {
        this.overAllScore.forEach((data) => {
          output.score += data.score
          output.full_score += data.full_score
        })
      }
      return output
    },
    workplaceEmail() {
      var data = null
      if (this.value && this.value.sessionvalue) {
        try {
          data = JSON.parse(this.value.sessionvalue)
        } catch (error) {
          data = null
        }
        return data.mail ? data.mail : ''
      } else {
        return ''
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function () {
      var vm = this
      return vm.user.intentlist.sort(function (a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  },
  mounted: function () {
    this.user = this.value
    this.cached_tag = this.user.tags
    if (this.user.json_variable) {
      try {
        Object.assign(this.user, JSON.parse(this.user.json_variable))
      } catch (error) {}
    }
  },
  methods: {
    handleClickCloseChapter() {
      this.activeChater = null
      this.currentScore = null
    },
    handleClickChapter(data) {
      this.currentScore = data
      this.activeChater = data.chapter
    },
    clearText(text) {
      if (text) {
        return text.replace(/\{savesession\(.*?\,.*?\)\}/gim, '')
      }
      return ''
    },
    async fetchScore() {
      let res = await api.atomicboyscorebyuserid(this.user.id)
      if (res && res.length) {
        this.overAllScore = res
      }
      let res2 = await api.getatomicboyscoreuser(this.user.id)
      if (res2 && res2.length) {
        this.interestingData = res2[0].interested
      }
      this.series = []
      this.chartOptions.labels = []
      for (const key in this.interestingData) {
        if (this.interestingData[key] > 0) {
          this.series.push(parseFloat(this.interestingData[key]))
          this.chartOptions.labels.push(key)
        }
      }
      this.updateChart = this.updateChart + 5

      let res3 = await api.getJsonlog(this.user.id)
      if (res3) {
        this.ansData = res3
      }
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags
      }
      api.saveUserTags(data, function (error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('overmaxlength')
        obj.error('overmaxlength:25')
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error('duplicate')
      } else obj.addTag()
    },
    clickShowFullQuestion(data, fullData) {
      this.fullQuestionData = JSON.parse(data)
      this.quickReply = fullData.quick_reply.split(',')
      this.showFullQuestion = true
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value
      }
      api.saveUserStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value
      }
      api.saveUserEmail(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value
      }
      api.saveUserPhoneno(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  }
}
</script>

<style scoped>
.hover-box-shadow {
  box-shadow: 0 5px 5px -3px rgb(0 0 0 / 0%), 0 8px 10px 1px rgb(0 0 0 / 0%),
    0 3px 14px 2px rgb(0 0 0 / 0%);
  transition: box-shadow 0.3s ease-in-out;
}
.hover-box-shadow:hover {
  box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%),
    0 3px 14px 2px rgb(0 0 0 / 12%);
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/atomicboy/AtomicboyCustomerItem.vue